<template>
  <div class="entitlement_details">
    <b-row
      class="content-header"
    >
      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ entitlement.stringID }} - {{ entitlement.name }}
            </h1>
            <p class="log_info">
              Created by {{ entitlement.createdBy ? entitlement.createdBy.name : '' }} on {{ entitlement.createdAt ? dateFormatWithTime(entitlement.createdAt) : '' }} <br>Last updated on {{ entitlement.updatedAt ? dateFormatWithTime(entitlement.updatedAt) : '' }}
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        class="content-header-right text-md-right mb-1"
        md="3"
        cols="12"
      >
        <div class="user_block low-width">
          <b-dropdown
            variant="flat-primary"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreHorizontalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('undo-redemption', 'Entitlement') && entitlement.status == 'redeemed'"
              @click="undoRedemption(entitlement)"
            >
              <feather-icon icon="RotateCcwIcon" />
              <span class="align-middle ml-50">Undo Redemption</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('mark-as-redeemable', 'Entitlement') && entitlement.status == 'cancelled'"
              @click="markAsRedeemable(entitlement)"
            >
              <feather-icon icon="CheckIcon" />
              <span class="align-middle ml-50">Mark as Redeemable</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('mark-as-redeemed', 'Entitlement') && (entitlement.status == 'redeemable' || entitlement.status == 'cancelled')"
              @click="markAsRedeemed(entitlement)"
            >
              <feather-icon icon="CheckIcon" />
              <span class="align-middle ml-50">Mark as Redeemed</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('mark-as-cancelled', 'Entitlement') && entitlement.status == 'redeemable'"
              @click="markAsCancelled(entitlement)"
            >
              <feather-icon icon="XCircleIcon" />
              <span class="align-middle ml-50">Mark as Cancelled</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('send-email', 'Entitlement')"
              @click="sendEmail(entitlement)"
            >
              <feather-icon icon="MailIcon" />
              <span class="align-middle ml-50">Re-send Email</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement') && (entitlement.status == 'redeemable' || entitlement.status == 'expired')"
              id="toggle-btn"
              v-b-modal.modal-update-validuntil-all-entitlement
              @click="setEntitlement(entitlement)"
            >
              <feather-icon icon="CheckCircleIcon" />
              <span class="align-middle ml-50">Edit Validity</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement')"
              id="toggle-btn"
              v-b-modal.modal-update-remarks-all-entitlement
              @click="setEntitlementRemarks(entitlement)"
            >
              <feather-icon icon="MessageSquareIcon" />
              <span class="align-middle ml-50">Edit Internal Remarks</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="user_block pr_stage_type">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Entitlement Status</h6>
            <h5 :class="`text-${resolveStatusVariant(entitlement.status)}`">
              {{ entitlement.status }}
            </h5>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col md="6">
        <b-card
          header-tag="header"
          class=""
        >
          <div class="d-flex justify-content-between align-items-center w-100 header_part">
            <h5 class="mb-0">
              Entitlement Details
            </h5>
          </div>
          <b-table-simple
            borderless
            responsive
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  Entitlement
                </b-th>
                <b-td class="mt-50">
                  {{ entitlement.name }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Related File
                </b-th>
                <b-td class="mt-50">
                  <div
                    v-if="entitlement.fileID"
                    class="text-nowrap"
                  >
                    <b-button
                      v-if="canViewThisAction('show', 'File')"
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="weight-600 align-middle detail-view-id"
                      :to="{ name: 'customers-files-show', params: { id: entitlement.fileID.fileID } }"
                    >
                      {{ entitlement.fileID.fileNo }}
                    </b-button>
                    <b-button
                      v-else
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="text-bold align-middle detail-view-id not-button"
                    >
                      {{ entitlement.fileID.fileNo }}
                    </b-button>
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Entitlement Scheme
                </b-th>
                <b-td class="mt-50">
                  <div
                    v-if="entitlement.schemeID"
                    class="text-nowrap"
                  >
                    <b-button
                      v-if="canViewThisAction('show', 'EntitlementScheme')"
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="weight-600 align-middle detail-view-id"
                      :to="{ name: 'products-schemes-show', params: { id: entitlement.schemeID ? entitlement.schemeID._id : '0' } }"
                    >
                      {{ entitlement.schemeID.name }}
                    </b-button>
                    <b-button
                      v-else
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="text-bold align-middle detail-view-id not-button"
                    >
                      {{ entitlement.schemeID.name }}
                    </b-button>
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Entitlement Item Type
                </b-th>
                <b-td class="mt-50">
                  {{ entitlement.schemeItemID ? resolveTypeValue(entitlement.schemeItemID.type) : '' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Validity
                </b-th>
                <b-td class="mt-50">
                  <div
                    v-if="entitlement.lifeTime"
                    class="text-nowrap"
                  >
                    <span class="">Life Time</span>
                  </div>
                  <div
                    v-else-if="entitlement.validUntil"
                    class="text-nowrap"
                  >
                    <span class="">{{ dateFormat(entitlement.validUntil) }}</span>
                  </div>
                  <div v-else>
                    -
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Paid Entitlement
                </b-th>
                <b-td class="mt-50">
                  {{ entitlement.isPaidEntitlement ? 'Yes' : 'No' }}
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <hr class="dividerHR">
          <b-table-simple
            borderless
            responsive
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  internal remarks
                </b-th>
                <b-td class="mt-50">
                  <span class="mt-50">
                    {{ entitlement.internalRemarks }}
                  </span>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card
          header-tag="header"
          class=""
        >
          <div class="d-flex justify-content-between align-items-center w-100 header_part">
            <h5 class="mb-0">
              Source of Entitlement (Sales Order)
            </h5>
          </div>
          <b-table-simple
            borderless
            responsive
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  Sales Order No.
                </b-th>
                <b-td class="mt-50">
                  -
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Lot No.
                </b-th>
                <b-td class="mt-50">
                  -
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Lot Type
                </b-th>
                <b-td class="mt-50">
                  -
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Product Description
                </b-th>
                <b-td class="mt-50">
                  -
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Purchaser Name
                </b-th>
                <b-td class="mt-50">
                  -
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Order Total
                </b-th>
                <b-td class="mt-50">
                  -
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Sales Order Date
                </b-th>
                <b-td class="mt-50">
                  -
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Applied Promotion
                </b-th>
                <b-td class="mt-50">
                  -
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
    </b-row>

    <b-card
      title="Related to this Entitlement"
      class="p-2"
    >
      <b-card-text>
        <b-tabs
          class="purchaser-tabs"
          content-class="mt-2"
        >
          <b-tab
            v-if="canViewThisAction('read', 'ServiceRequest')"
            lazy
            title="Sales Order"
          />
          <b-tab
            v-if="canViewThisAction('read', 'ServiceRequest')"
            lazy
            title="Service Requests"
          />
          <b-tab
            v-if="canViewThisAction('read', 'InventoryItem')"
            lazy
            title="Inventory Item"
          />
        </b-tabs>
      </b-card-text>
    </b-card>

    <b-card
      header-tag="header"
    >
      <div class="d-flex justify-content-between align-items-center w-100 header_part">
        <h5 class="align-middle mr-auto">
          Selected Option
        </h5>
        <b-button
          v-if="entitlement.status == 'redeemable'"
          variant="flat-primary"
          class="selected-option-edit-btn"
          :disabled="['expired', 'cancelled'].includes(entitlement.status)"
          @click="openEditSelectedOption"
        >
          <feather-icon
            icon="EditIcon"
            size="14"
            class="mr-50"
          />
          Edit
        </b-button>
      </div>

      <b-table-simple
        small
        responsive
        class="has_padding shadow-table"
      >
        <b-thead>
          <b-tr>
            <b-th>Inventory item Option</b-th>
            <b-th>Quantity</b-th>
            <b-th>Store</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="(inv, index) in entitlement.selectedOptions"
            :key="index"
          >
            <b-td>
              <div class="d-flex align-items-center">
                <img
                  :src="inv.inventoryItemId ? (inv.inventoryItemId.image ? inv.inventoryItemId.image : require('@/assets/images/placeholder/placeholder_image.png')) : require('@/assets/images/placeholder/placeholder_image.png')"
                  alt="item image"
                  class="mr-1"
                  style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px; border: 1px solid #D2DCEA;"
                >
                <div class="item_name">
                  {{ inv.inventoryItemId ? inv.inventoryItemId.name : '' }}
                </div>
              </div>
            </b-td>
            <b-td>{{ inv.quantity }}</b-td>
            <b-td>{{ inv.store ? inv.store.name : '' }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-nav
        v-if="entitlement.status == 'redeemable'"
        class="wrap-border save-nav"
      >
        <li class="nav-item ml-1 my-auto">
          <span>This entitlement is ready to be redeemed.</span>
        </li>
        <li
          v-if="hasProcessingSession"
          class="nav-item ml-auto my-auto"
        >
          <span class="redeem-timer text-danger font-weight-bold">{{ formattedCountdown }}</span>
        </li>
        <li
          class="nav-item my-auto"
          :class="hasProcessingSession ? 'ml-2' : 'ml-auto'"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mr-1"
            @click="proceedToRedeem"
          >
            <feather-icon
              icon="GiftIcon"
              size="16"
              class="mr-50"
            />
            Proceed to Redeem
          </b-button>
        </li>
      </b-nav>
    </b-card>

    <b-card
      class="mb-3 mt-3 p-2"
    >
      <b-row
        class="content-header"
      >
        <!-- Content Left -->
        <b-col
          class="content-header-left pb-2"
          cols="12"
          md="12"
        >
          <h4>
            <feather-icon
              icon="ListIcon"
              class="mr-50"
              size="16"
            />
            <span class="align-middle">Activity Logs</span>
          </h4>
        </b-col>
      </b-row>
      <app-timeline>
        <!-- FINANCIAL REPORT -->
        <app-timeline-item
          v-for="(opt, key) in entitlementDetailActivityLogs"
          :key="key"
          :variant="getVariant(key)"
        >

          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6>{{ opt.title }}</h6>
            <small class="text-muted">{{ dateFormatWithTime(opt.time) }}</small>
          </div>
          <b-button
            v-if="opt.activityDetails && opt.activityDetails.length"
            v-b-toggle="'report-list-with-icon-' + key"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            size="sm"
            variant="outline-primary"
          >
            Details
            <feather-icon
              icon="ChevronUpIcon"
              class="ml-50 when-open"
              size="16"
            />
            <feather-icon
              icon="ChevronDownIcon"
              class="ml-50 when-closed"
              size="16"
            />
          </b-button>
          <b-collapse
            v-if="opt.activityDetails && opt.activityDetails.length"
            :id="'report-list-with-icon-' + key"
          >
            <b-table-simple
              borderless
              responsive
            >
              <b-tbody>
                <b-tr
                  v-for="(activityDetail, activitykey) in opt.activityDetails"
                  :key="activitykey"
                >
                  <b-th style="width: 300px; max-width: 300px;">
                    {{ activityDetail.title }}
                  </b-th>
                  <b-td>{{ activityDetail.oldValue }}</b-td>
                  <b-td>{{ activityDetail.newValue }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-collapse>
        </app-timeline-item>
      </app-timeline>
    </b-card>

    <b-modal
      id="modal-redemption-code"
      ref="redemption-code-modal"
      centered
      hide-footer
      modal-class="redemption-code-modal"
      no-close-on-backdrop
      @hide="onRedemptionModalHide"
    >
      <template #modal-header>
        <button
          type="button"
          class="close"
          @click="$bvModal.hide('modal-redemption-code')"
        >
          ×
        </button>
      </template>
      <div class="text-center redemption-wrapper">

        <!-- Gift Icon -->
        <div class="gift-icon-wrapper">
          <feather-icon
            v-if="isExpired"
            icon="ClockIcon"
            size="80"
            class="clock-icon"
          />
          <feather-icon
            v-else
            icon="GiftIcon"
            size="80"
            class="gift-icon"
          />
        </div>

        <!-- Title -->
        <h3 class="redemption-title">
          {{ isExpired ? 'The redemption code is expired.' : 'Enter Redemption Code' }}
        </h3>
        <!-- Description -->
        <p class="redemption-description">
          {{ isExpired ? 'Please request a new redemption code from the customer.' : 'This code can be generated only by customer using their Nirvana SG customer app for verification purposes.' }}
        </p>

        <!-- Code Inputs -->
        <div class="redemption-code-group">
          <div
            v-for="(code, index) in redemptionCode"
            :key="index"
            class="code-wrapper"
          >
            <b-form-input
              v-model="redemptionCode[index]"
              maxlength="1"
              class="code-input"
              @paste="handlePaste"
              @input="handleInput(index, $event)"
            />

            <!-- Hyphen after 4th digit -->
            <span
              v-if="index === 3"
              class="divider"
            >
              —
            </span>
          </div>
        </div>
        <div
          v-if="redemptionCodeError"
          class="text-danger text-center mb-1"
          style="font-size: 13px;"
        >
          <feather-icon
            icon="AlertCircleIcon"
            size="14"
            class="mr-25"
          />
          {{ redemptionCodeError }}
        </div>

        <!-- Bottom Line -->
        <div class="bottom-line" />

        <!-- Buttons -->
        <div class="d-flex justify-content-center mt-2">
          <b-button
            variant="outline-primary"
            class="mr-1 px-2"
            @click="$bvModal.hide('modal-redemption-code')"
          >
            Cancel
          </b-button>

          <b-button
            variant="primary"
            class="px-2"
            @click="redeemEntitlement"
          >
            Redeem this Entitlement
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-edit-selected-option"
      ref="selected-code-modal"
      centered
      hide-footer
      modal-class="edit-selected-option-modal"
      title="Edit Selected Option"
    >
      <div class="inventory-option-list">
        <div
          v-for="(item, index) in inventoryOptions"
          :key="index"
          class="inventory-option-card"
          :class="{ active: isSelected(item) }"
          @click="selectSingleOption(item)"
        >
          <img
            :src="item.item.image ? item.item.image : require('@/assets/images/placeholder/placeholder_image.png')"
            class="option-image"
          >

          <div class="option-content">
            <h5 class="option-title">
              {{ item.item ? item.item.name : '' }}
            </h5>
            <p class="option-sub">
              {{ item.item ? item.item.sku : '-' }}
            </p>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          @click="$bvModal.hide('modal-edit-selected-option')"
        >
          Cancel
        </b-button>

        <b-button
          variant="success"
          :disabled="selectedOptionTemp.length == 0"
          @click="saveSelectedOption"
        >
          Save Changes
        </b-button>
      </div>
    </b-modal>
    <b-modal
      id="modal-update-validuntil-all-entitlement"
      ref="update-status-modal"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Save Changes"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Edit Validity"
      @ok="submitForm"
    >
      <b-form @submit.prevent="submitForm">
        <validation-observer
          ref="entitlementValidUntilEditForm"
        >
          <!-- <b-form-group
            label="Valid Until*"
            label-for="h-entitlement-validUntil"
          >
            <validation-provider
              #default="{ errors }"
              name="Valid Until"
              vid="validUntil"
              rules="required"
            >
              <b-input-group>
                <flat-pickr
                  id="h-validUntil"
                  v-model="validUntil"
                  class="form-control flat-pickr-group"
                  placeholder="Valid Until"
                  :config="flatPickrConfig"
                  @input="validUntilValidation == true ? validUntilValidation = false : null"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="CalendarIcon"
                    class="cursor-pointer"
                    data-toggle
                    size="18"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="validUntilValidation"
                class="text-danger"
              >
                {{ validUntilError }}
              </small>
            </validation-provider>
          </b-form-group> -->
          <b-form-group class="regular-label">
            <div>
              <div
                class="d-flex"
                style="gap: 10px;"
              >
                <div style="width: 50%;">
                  <!-- Validity Year -->
                  <validation-provider
                    #default="{ errors }"
                    name="Validity Year"
                    vid="validityYear"
                  >
                    <v-select
                      id="h-scheme-validityYear"
                      v-model="validityYear"
                      label="title"
                      :options="validityYears"
                      :reduce="title => title.code"
                      :clearable="false"
                      :disabled="lifeTime"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div style="width: 50%;">
                  <!-- Validity Type -->
                  <validation-provider
                    #default="{ errors }"
                    name="Validity Type"
                    vid="validityType"
                  >
                    <v-select
                      id="h-scheme-validityType"
                      v-model="validityType"
                      label="title"
                      :options="validityTypes"
                      :reduce="title => title.code"
                      :clearable="false"
                      :disabled="lifeTime"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div
              class="flex-grow-1 d-flex justify-content-start"
              style="padding-top:8px;"
            >
              <!-- ✅ New Checkbox -->
              <b-form-checkbox
                v-model="lifeTime"
                class="mt-0"
                style="white-space: nowrap;"
              >
                Lifetime
              </b-form-checkbox>
            </div>
            <small class="text-muted-999">
              From date of issuance, as assigned when this entitlement is issued to a customer. Customer will have this period of time to redeem/consume this entitlement.
            </small>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
    <b-modal
      id="modal-update-remarks-all-entitlement"
      ref="update-remarks-modal"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Save Changes"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Edit Internal Remarks"
      @ok="submitRemarksForm"
    >
      <b-form @submit.prevent="submitRemarksForm">
        <validation-observer
          ref="entitlementRemarksEditForm"
        >
          <b-form-group
            label-for="h-entitlement-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <b-form-textarea
                id="h-remarks"
                v-model="internalRemarks"
                placeholder="Internal Remarks"
                :state="(errors.length > 0 || remarksValidation) ? false : null"
                name="remarks"
                rows="3"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="remarksValidation"
                class="text-danger"
              >
                {{ remarksError }}
              </small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BButton, BCol, BTableSimple, BTbody, BTr, BTh, BThead, BTd, VBTooltip, BForm, BFormGroup,
  BFormInput, BTab, BTabs, BCardText, BDropdown, BDropdownItem, BFormTextarea, BFormCheckbox, BNav,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import 'array.prototype.move'
import store from '@/store/index'
import { required } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
// import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import ToastificationContentCustom from '../ToastificationContentCustom.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BRow,
    BButton,
    BCol,
    BTab,
    BTabs,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BThead,
    BTd,
    BForm,
    BFormGroup,
    BFormInput,
    BCardText,
    BDropdown,
    BDropdownItem,
    BFormTextarea,
    BFormCheckbox,
    BNav,

    ValidationProvider,
    ValidationObserver,
    // flatPickr,
    vSelect,
    AppTimeline,
    AppTimelineItem,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      entitlementID: '',
      inventoryOptions: [],
      selectedOptionTemp: [],
      topSpacing: 135,
      canViewThisAction,
      entitlement: {},
      entitlementDetailActivityLogs: [],
      status: '',
      redeemUntil: '',
      hasProcessingSession: false,
      statusValidation: false,
      statusError: 'Valid status is required',
      name: '',
      validUntil: '',
      validUntilValidation: false,
      validUntilError: 'Valid status is required',
      internalRemarks: '',
      remarksValidation: false,
      remarksError: 'Internal Remarks is required',
      statusDataOptions: [
        { title: 'Redeemable', code: 'redeemable' },
        { title: 'Redeemed', code: 'redeemed' },
        { title: 'Used', code: 'used' },
        { title: 'Expired', code: 'expired' },
        { title: 'Cancelled', code: 'cancelled' },
      ],
      redemptionCode: ['', '', '', '', '', '', '', ''],
      redemptionCodeError: '',
      countdown: 0,
      countdownInterval: null,
      flatPickrConfig: {
        wrap: true, enableTime: false, dateFormat: 'd/m/Y', disableMobile: true,
      },
      lifeTime: false,
      validityYear: 3,
      validityType: 'Years',
      validityTypes: [
        { title: 'Months', code: 'Months' },
        { title: 'Years', code: 'Years' },
      ],
      validityYears: Array.from({ length: 9 }, (_, i) => ({
        title: (i + 1).toString(),
        code: i + 1,
      })),
      required,
    }
  },
  computed: {
    formattedCountdown() {
      const minutes = Math.floor(this.countdown / 60)
      const seconds = this.countdown % 60

      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} mins left`
    },
    isExpired() {
      return this.hasProcessingSession && this.countdown <= 0
    },
  },
  created() {
    this.getEntitlementScheme()
    if (this.$route.query.processingExpiresAt) {
      this.hasProcessingSession = true
      this.redeemUntil = this.$route.query.processingExpiresAt
      this.startCountdown()
    }
  },
  beforeDestroy() {
    this.stopCountdown()
  },

  methods: {
    resolveTypeValue(type) {
      if (type === 1) return 'Inventory-managed item'
      if (type === 2) return 'Funeral Service Package'
      if (type === 3) return 'Non-inventory-managed item'
      return ''
    },
    undoRedemption(id) {
      this.$swal({
        title: 'Undo Redemption?',
        html: 'Undoing this redemption will also cancel the associated Inventory Request. This action cannot be undone. Do you want to proceed?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Go back',
        confirmButtonText: 'Undo Redemption',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'redeemable', true)
          }
        })
    },
    markAsRedeemable(id) {
      this.$swal({
        title: 'Mark as Redeemable?',
        html: 'Are you sure you want to mark this item as redeemable? Once enabled, users may proceed with redemption.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Yes, Mark as Redeemable',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'redeemable')
          }
        })
    },
    markAsRedeemed(id) {
      this.$swal({
        title: 'Mark as Redeemed?',
        html: 'Are you sure you want to redeem this entitlement? This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/success-square.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Go back',
        confirmButtonText: 'Yes, Mark as Redeemed',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        width: 475,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'redeemed')
          }
        })
    },
    markAsCancelled(id) {
      this.$swal({
        title: 'Mark as Cancelled?',
        html: 'Are you sure you want to cancel this entitlement? This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning-square.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Go back',
        confirmButtonText: 'Yes, Mark as Cancelled',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        width: 475,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'cancelled')
          }
        })
    },
    changeRoute(param) {
      this.$router.replace({
        params: {
          type: param,
        },
        query: {},
      })
    },
    isSelected(item) {
      return this.selectedOptionTemp.some(i => (i.inventoryItemId?._id || i.item._id) === item.item._id)
    },
    selectOption(item) {
      const id = item.item._id

      const index = this.selectedOptionTemp.findIndex(i => (i.inventoryItemId?._id || i.item?._id) === id)

      if (index !== -1) {
        // 🔴 already selected → remove (deselect)
        this.selectedOptionTemp.splice(index, 1)
      } else {
        // 🟢 not selected → add
        this.selectedOptionTemp.push(item)
      }
    },
    selectSingleOption(item) {
      const id = item.item._id
      const alreadySelected = this.selectedOptionTemp.some(i => (i.inventoryItemId?._id || i.item?._id) === id)
      this.selectedOptionTemp = alreadySelected ? [] : [item]
    },
    saveSelectedOption() {
      const payload = {
        selectedOptions: this.selectedOptionTemp.map(item => ({
          inventoryItemId: item.item ? item.item._id : item.inventoryItemId._id,
          quantity: item.quantity || 1,
          store: item.store || null,
        })),
      }

      this.$http.patch(
        `customer/entitlements/${this.$route.params.id}/selected-options/update`,
        payload,
      )
        .then(() => {
          this.getEntitlementScheme()
          this.$bvModal.hide('modal-edit-selected-option')
        })
    },
    openEditSelectedOption() {
      this.selectedOptionTemp = this.entitlement.selectedOptions.map(i => ({ ...i }))
      this.$bvModal.show('modal-edit-selected-option')
    },
    onRedemptionModalHide() {
      this.redemptionCode = ['', '', '', '', '', '', '', '']
      this.redemptionCodeError = ''
      if (this.isExpired) {
        this.hasProcessingSession = false
        this.stopCountdown()
      }
    },
    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval)
        this.countdownInterval = null
      }
    },
    startCountdown() {
      this.stopCountdown()
      if (!this.redeemUntil) {
        this.countdown = 0
        return
      }

      const expiryTime = new Date(this.redeemUntil).getTime()

      const updateCountdown = () => {
        const now = Date.now()
        const remaining = Math.floor((expiryTime - now) / 1000)

        this.countdown = remaining > 0 ? remaining : 0

        if (remaining <= 0) {
          this.stopCountdown()
        }
      }

      updateCountdown()

      this.countdownInterval = setInterval(() => {
        updateCountdown()
      }, 1000)
    },
    proceedToRedeem() {
      if (this.hasProcessingSession && !this.isExpired) {
        const formData = new FormData()
        formData.append('code', this.$route.query.redeemCode)
        this.$http.post(`customer/entitlements/${this.$route.params.id}/finalize-redeem`, formData)
          .then(() => {
            this.getEntitlementScheme()
            this.$swal({
              title: 'Item has been redeemed',
              html: '',
              // eslint-disable-next-line global-require
              imageUrl: require('@/assets/images/icons/save.png'),
              imageWidth: 80,
              imageHeight: 80,
              imageAlt: 'Custom Icon',
              showCancelButton: false,
              confirmButtonText: 'Okay',
              customClass: { confirmButton: 'btn btn-primary' },
              buttonsStyling: false,
            })
          })
          .catch(error => {
            const action = error.data?.action
            if (action === 'request_new_code') {
              this.countdown = 0
            }
            this.redemptionCodeError = error.data?.message ?? 'Something went wrong. Please try again.'
            this.$bvModal.show('modal-redemption-code')
          })
      } else {
        this.$bvModal.show('modal-redemption-code')
      }
    },
    handlePaste(event) {
      event.preventDefault()

      const pastedData = (event.clipboardData || window.clipboardData)
        .getData('text')
        .replace(/\D/g, '')
        .slice(0, 8)

      if (!pastedData) return

      pastedData.split('').forEach((char, index) => {
        this.$set(this.redemptionCode, index, char)
      })
    },

    handleInput(index, value) {
      const cleaned = (value || '').replace(/\D/g, '').slice(0, 1)
      this.$set(this.redemptionCode, index, cleaned)
      if (this.redemptionCodeError) this.redemptionCodeError = ''
      if (cleaned && index < 7) {
        this.$nextTick(() => {
          const inputs = document.querySelectorAll('.code-input')
          if (inputs[index + 1]) inputs[index + 1].focus()
        })
      }
    },
    redeemEntitlement() {
      const code = this.redemptionCode.join('')
      // Basic validation before calling API
      if (code.length < 8) {
        this.redemptionCodeError = 'Please enter the complete 8-digit redemption code.'
        return
      }

      this.redemptionCodeError = ''
      const formData = new FormData()
      formData.append('code', code)

      this.$http.post(`customer/entitlements/${this.$route.params.id}/finalize-redeem`, formData)
        .then(() => {
          this.$bvModal.hide('modal-redemption-code')
          this.getEntitlementScheme()
          this.$swal({
            title: 'Item has been redeemed',
            html: '',
            // eslint-disable-next-line global-require
            imageUrl: require('@/assets/images/icons/save.png'),
            imageWidth: 80,
            imageHeight: 80,
            imageAlt: 'Custom Icon',
            showCancelButton: false,
            confirmButtonText: 'Okay',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        })
        .catch(error => {
          if (error.data.errors) {
            error.data.errors.forEach(() => {
              const codeError = error.data.errors.find(e => e.param === 'code')
              if (codeError) {
                this.redemptionCodeError = codeError.msg
              }
            })
          } else {
            this.redemptionCodeError = error.data?.message ?? 'Invalid redemption code. Please try again.'
          }
        })

      // Example: 12345678
    },
    getVariant(key) {
      if (key % 4 === 0) return 'info'
      if (key % 4 === 1) return 'warning'
      if (key % 4 === 2) return 'danger'
      if (key % 4 === 3) return 'purple'
      return 'primary'
    },
    resolveStatusVariant(status) {
      if (status === 'redeemable') return 'success'
      if (status === 'redeemed') return 'primary'
      if (status === 'used') return 'primary'
      if (status === 'expired') return 'secondary'
      if (status === 'cancelled') return 'danger'
      return 'primary'
    },

    getEntitlementScheme() {
      this.$http.get(`customer/entitlements/${this.$route.params.id}/show`)
        .then(response => {
          this.entitlement = response.data.entitlement || {}
          this.inventoryOptions = response.data.schemeItem?.inventoryOptions ?? []
          this.status = this.entitlement.status
          store.commit('breadcrumb/REMOVE_BREADCRUMB')
          const newMeta = {
            active: true,
            text: `${this.entitlement.stringID} - ${this.entitlement.name}`,
          }
          store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
          this.entitlementDetailActivityLogs = this.entitlement.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    setEntitlement(item) {
      this.entitlementID = item._id
      this.validUntil = item.validUntil
      this.name = item.name
    },
    setEntitlementRemarks(item) {
      this.entitlementID = item._id
      this.internalRemarks = item.internalRemarks
      this.name = item.name
    },
    submitForm() {
      this.$refs.entitlementValidUntilEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('lifeTime', this.lifeTime)
          formData.append('validityYear', this.validityYear)
          formData.append('validityType', this.validityType)

          this.$http.patch(`customer/entitlements/${this.entitlementID}/validity/update`, formData)
            .then(() => {
              this.getEntitlementScheme()
              this.$swal({
                title: 'Validity has been updated',
                // html: `The validity for <strong>'${this.name}'</strong> has been updated`,
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/success.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                showConfirmButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                width: 300,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'validUntil') {
                    this.validUntilError = validationError.msg
                    this.validUntilValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
    sendEmail(entitlement) {
      if (entitlement.customerID && entitlement.customerID.perEmail === null) {
        this.$swal({
          // eslint-disable-next-line global-require
          title: 'No email address found', html: 'The customer has not provided an email address.', imageUrl: require('@/assets/images/icons/warning.png'), imageWidth: 80, imageHeight: 80, imageAlt: 'Custom Icon', showCancelButton: false, confirmButtonText: 'Okay', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false,
        })
        return
      }
      this.$swal({
        // eslint-disable-next-line global-require
        title: 'Re-send Entitlement Email?', html: `An email containing the entitlement details and current status will be sent to ${entitlement.customerID ? entitlement.customerID.perEmail : '-'}.`, imageUrl: require('@/assets/images/icons/mail.png'), reverseButtons: true, showCancelButton: true, cancelButtonText: 'Go back', confirmButtonText: 'Send Email', customClass: { confirmButton: 'btn btn-primary ml-1', cancelButton: 'btn btn-outline-primary' }, buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.$http.post(`customer/entitlements/${entitlement._id}/send-email`)
              .then(() => {
                this.$swal({
                  // eslint-disable-next-line global-require
                  title: 'The entitlement status email has been sent', imageUrl: require('@/assets/images/icons/success.png'), imageWidth: 80, imageHeight: 80, imageAlt: 'Custom Icon', showCancelButton: false, showConfirmButton: false, buttonsStyling: false,
                })
              })
          }
        })
    },
    updateStatus(entitlement, status, undo = false) {
      const formData = new FormData()
      formData.append('status', status)
      this.$http.patch(`customer/entitlements/${entitlement._id}/status/update`, formData)
        .then(() => {
          this.getEntitlementScheme()
          if (status === 'redeemed') {
            const toastMessage = `<span class="text-bold-black">${entitlement.stringID} - ${entitlement.name}</span> has been mark as redeemed successfully.`
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Mark as Redeemed', text: toastMessage, icon: 'CheckCircleIcon', variant: 'success', hideClose: true,
              },
            })
          } else if (status === 'cancelled') {
            const toastMessage = `<span class="text-bold-black">${entitlement.stringID} - ${entitlement.name}</span> has been mark as cancelled successfully.`
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Mark as Cancelled', text: toastMessage, icon: 'CheckCircleIcon', variant: 'success', hideClose: true,
              },
            })
          } else if (status === 'redeemable' && !undo) {
            const toastMessage = `<span class="text-bold-black">${entitlement.stringID} - ${entitlement.name}</span> has been mark as redeemable successfully.`
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Mark as Redeemable', text: toastMessage, icon: 'CheckCircleIcon', variant: 'success', hideClose: true,
              },
            })
          } else if (status === 'redeemable' && undo) {
            // eslint-disable-next-line global-require
            this.$swal({
              // eslint-disable-next-line global-require
              title: 'Redemption has been reverted.', imageUrl: require('@/assets/images/icons/success.png'), imageWidth: 80, imageHeight: 80, imageAlt: 'Custom Icon', showCancelButton: false, showConfirmButton: false, buttonsStyling: false,
            })
          }
        })
        .catch(error => {
          if (error.data.status === 'collected') {
            // eslint-disable-next-line global-require
            this.$swal({
              // eslint-disable-next-line global-require
              title: 'Unable to Undo Redemption', html: 'This entitlement has already been collected and its redemption can no longer be reversed.', imageUrl: require('@/assets/images/icons/alert-red.png'), imageWidth: 80, imageHeight: 80, imageAlt: 'Custom Icon', showCancelButton: false, confirmButtonText: 'Close', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false,
            })
          } else {
            this.$toast({ component: ToastificationContent, props: { title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE, icon: 'AlertTriangleIcon', variant: 'danger' } })
          }
        })
    },
    submitRemarksForm() {
      this.$refs.entitlementRemarksEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('internalRemarks', this.internalRemarks)

          this.$http.patch(`customer/entitlements/${this.entitlementID}/internal-remarks/update`, formData)
            .then(() => {
              this.getEntitlementScheme()
              this.$swal({
                title: 'Internal Remarks has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/success.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                showConfirmButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                width: 300,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'internalRemarks') {
                    this.remarksError = validationError.msg
                    this.remarksValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
.display-content {
  display: contents;
}

.custom-th-width {
  .table th {
      padding: 0.72rem 2rem 0.72rem 0.72rem;
  }
}
.redemption-code-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.code-input {
  width: 48px;
  height: 48px;
  text-align: center;
  font-size: 20px;
  border-radius: 6px;
  border: 1px solid #d8d8d8;

  &:focus {
    border-color: #0052cc;
    box-shadow: none;
  }
}
.code-wrapper {
  display: flex;
  align-items: center;
}
.clock-icon {
  color: #f59e0b;
}
.redemption-wrapper {
  position: relative;
}

.modal-close-btn,
.close {
  position: relative;
  z-index: 9999;
}
// .inventory-option-card.active {
//   border: 2px solid #28c76f;
//   background-color: rgba(40, 199, 111, 0.1);
// }
.user_block.low-width {
  max-width: 66px;
  min-width: 66px;
  width: 66px;
  overflow: visible;
}
.user_block.low-width ul {
    left: auto !important;
    right: 0 !important;
}

.user_block.low-width button {
    width: 66px !important;
}

.btn-primary-dropdown a:hover {
  background-color: #104D9D !important;
  color: #fff !important;
}
</style>
